<template>
  <v-flex data-qa="loan-flex-vobnh">
    <Loader v-show="loaderEnabled"/>
    <v-layout wrap class="ml-2 pt-0" data-qa="loan-layout-s5z91d">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient }"
       data-qa="loan-flex-9qkz4">
        <v-container data-qa="loan-container-ab3grx">
          <v-flex xs12 sm12 md12 lg12 xl12 class="px-2" data-qa="loan-flex-xpfife">
            <v-flex xs12 sm10 md10 lg8 xl7 data-qa="loan-flex-9s2gt8">
              <v-row no-gutters class="pb-2" data-qa="loan-row-u5k9e">
                  <inline-svg
                    class="mt-2"
                    :src="getNavigationIcon()"
                    width="50"
                    height="50"
                    aria-label="Navigation Icon"
                  ></inline-svg>
                  <font class="display-1 font-weight-thin white--text pt-4 pl-2">
                    {{ $t("common.loanLabel") }} <font v-if="showTotalAccountsAvailable">({{loanAccount.accounts.length}})</font>
                  </font>
              </v-row>
            </v-flex>
            <v-row v-if="showTotalBalance" class="px-2 pl-6" data-qa="loan-row-ekhwn">
              <v-layout
                v-if="loanAccount.accounts && loanAccount.accounts.length"
                row
                wrap
               data-qa="loan-layout-jk0nh">
                <v-flex xs6 sm6 md6 lg6 xl6 class="px-1" data-qa="loan-flex-436sdxj">
                  <font class="subheading-1 font-weight-medium white--text"
                    >{{ $t("accountDetails.totalOutstandingBalance") }}
                  </font>
                </v-flex>
                <v-flex xs10 sm10 md10 lg10 xl10 class="px-1" data-qa="loan-flex-vhlvsp">
                  <font class="text-h5 font-weight-bold white--text"
                    >{{ $formatter.currency.format(accDetails.myBalance) }}
                  </font>
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex xs12 sm12 md12 lg9 xl9 class="pl-1 mt-4" data-qa="loan-flex-apyrnl">
      <CardLayout :config="loanAccount" />
    </v-flex>
  </v-flex>
</template>

<script>
import event from '@/util/event'
import preload from '@/util/preload'
import store from '@/core/store'
import CardLayout from '@/views/home/HomeCards.vue'
import Loader from '../../components/common/Loader.vue'

export default {
  name: 'Loan',
  components: {
    Loader,
    CardLayout
  },
  data () {
    return {
      loaderEnabled: false,
      loanAccount: {
        title: this.$t('common.loanLabel'),
        cardLabels: false,
        openNewACCard: false,
        enableShowMore: false,
        accounts: []
      },
      accDetails: {
        myBalance: 0,
        series: []
      },
      showTotalBalance: this.$appSettings.defaultConfigurations.totalBalanceSection.enableLoanSection,
      showTotalAccountsAvailable: this.$appSettings.defaultConfigurations.showTotalAccountsAvailable.enableLoanSection
    }
  },
  beforeCreate () {
    if (this.$route.params.reload) {
      location.reload()
    }
  },
  created () {
    if (this.$route.params && this.$route.params.from === 'Dashboard') {
      this.loanAccount.enableShowMore = true
    } else this.loanAccount.enableShowMore = false
    event.$on('set_myLoanAccounts', () => {
      this.getListOfLoanAccounts()
      this.loaderEnabled = false
    })
    if (this.ifMyAccountsAvailable()) {
      this.getListOfLoanAccounts()
    } else {
      this.loaderEnabled = true
      preload.getListOfLoanAccounts(
        JSON.parse(sessionStorage.getItem('username'))
      )
      this.loaderEnabled = false
    }
  },
  methods: {
    getNavigationIcon () {
      return this.getSvgIconSrc('Loan_Dashboard')
    },
    ifMyAccountsAvailable () {
      return store.getters['userStore/userData'].loanAccounts
    },
    async getListOfLoanAccounts () {
      this.loaderEnabled = true
      const loanAccounts = await store.getters['userStore/userData']
        .loanAccounts
      if (loanAccounts) {
        this.setLoanAccounts(loanAccounts)
      }
      this.loaderEnabled = false
    },
    setLoanAccounts (loanAccounts) {
      this.loanAccount.accounts = loanAccounts
      for (const i in loanAccounts) {
        this.accDetails.myBalance +=
          loanAccounts[i].loanOutstandingAmount.amount
      }
    }
  }
}
</script>
